import { Dimension, SuggestionType, WordSuggestionsResponse } from "./types";

export const minCharactersForSuggestion = 3;
export const topN = 3;

export const typeColorMap: Record<SuggestionType, string> = {
  FactDimensions: "#D65737", // Orange from theme
  KPI: "#4682B4", // Steel Blue
  defaultType: "#D65737", // Orange from theme
};

export const wordSuggestionsMock: WordSuggestionsResponse = {
  suggestions: [
    {
      fe_display: "BOOKING",
      be_display: "[Dim_Sources].[Source Code] = 'BOOKING'",
      tag: "Source - Code",
      type: "FactDimensions",
    },
    {
      fe_display: "BOOKING",
      be_display: "[Dim_Sources].[Source Name] = 'BOOKING'",
      tag: "Source - Name",
      type: "FactDimensions",
    },
    {
      fe_display: "Average Daily Rate",
      be_display: "Average Daily Rate",
      tag: "KPI",
      type: "KPI",
    },
  ],
};

export const dimensionMock: { dimensions: Dimension[] } = {
  dimensions: [
    {
      tag: "Hotel",
    },
    {
      tag: "KPI",
    },
    {
      tag: "Market",
    },
    {
      tag: "Reservation",
    },
    {
      tag: "Source",
    },
    {
      tag: "Transaction",
    },
    {
      tag: "UnitType",
    },
  ],
};
